import Color from 'color';

/** example `colorData`:
 * - `[
      [[0,0,0], [0,128,128], [0,0,255]],
      [[0,255,0], [128,128,0], [255,0,0]]
    ]`
    - `rgba(125,125,125,0.4)`
 */
export const colorArrayToDataUrl = (colorData) => {
  let rgbaPixels = colorData;

  if (typeof colorData === 'string') {
    rgbaPixels = [
      [
        Color(colorData)
          .rgb()
          .array()
          .map((p, idx) => (idx === 3 ? p * 255 : p))
      ]
    ];
  }

  const canvas = document.createElement('canvas');

  const rgbaPixelsFlat = rgbaPixels.reduce((acc, val) => {
    return [...acc, ...val];
  }, []);
  canvas.height = rgbaPixels.length;
  canvas.width = rgbaPixels[0].length;

  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d');
  const peekData = ctx.createImageData(canvas.width, canvas.height);
  for (let i = 0; i < peekData.data.length; i += 4) {
    peekData.data[i + 0] = rgbaPixelsFlat[Math.floor(i / 4)][0]; // R value
    peekData.data[i + 1] = rgbaPixelsFlat[Math.floor(i / 4)][1]; // G value
    peekData.data[i + 2] = rgbaPixelsFlat[Math.floor(i / 4)][2]; // B value
    peekData.data[i + 3] =
      rgbaPixelsFlat[Math.floor(i / 4)][3] !== undefined
        ? rgbaPixelsFlat[Math.floor(i / 4)][3]
        : 255; // A value
  }
  ctx.putImageData(peekData, 0, 0);
  document.body.removeChild(canvas);
  return canvas.toDataURL();
};
